module.exports = __webpack_public_path__ + "resources/img/img_akamaiAAP_en.58bb7d5a2148ffd343804eab67fd26b1.png";